import { render } from "./BlogPediatricDentistry.vue?vue&type=template&id=b08fe8b2"
import script from "./BlogPediatricDentistry.vue?vue&type=script&lang=js"
export * from "./BlogPediatricDentistry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__